import VueRouter from "vue-router";
import Vue from "vue";
import { routesList } from "./routerList"
Vue.use(VueRouter);


const router = new VueRouter({
  mode: "hash",
  routes: routesList
});

export default router;
